import FeaturesLayout from '@/components/layouts/FeaturesLayout';
import DefaultTemplate from '@/components/templates/Default';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import React from 'react';

export default function Features() {
  return (
    <DefaultTemplate>
      <FeaturesLayout />
    </DefaultTemplate>
  );
}

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale as string, [`common`, `features`])),
  },
});
